module.exports = __webpack_public_path__ + "static/media/word.b032c48c.svg";